import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  MonthlyPeriod,
  StringifyMonthlyPeriod,
  StringifyOnlyMonthlyPeriod,
} from "../../../../Model/overview";
import { MenuItem, Select } from "@mui/material";
import { portalStore } from "../../../../Stores/portal";
import axios from "axios";
import {
  MinifiedTransaction,
  Transaction,
} from "../../../../Model/transaction";

const AccountingDashboard: React.FC = () => {
  const [period, setPeriod] = useState<MonthlyPeriod | null>(null);
  const [periods, setPeriods] = useState<MonthlyPeriod[]>([]);
  const [transactions, setTransactions] = useState<MinifiedTransaction[]>([]);
  const [monthTotalEarning, setMonthTotalEarning] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchData = (period: MonthlyPeriod) => {
    if (period == null) return;
    console.log("Period Object", period);
    setLoading(true);
    axios
      .get(
        `https://wallof-backend.uc.r.appspot.com/business/accounting/dashboard/${
          period.year
        }/${period.month + 1}`
      )
      .then((x) => {
        const data = x.data["data"] as MinifiedTransaction[];
        console.log(data);
        var earnings = 0;
        data.forEach((element) => {
          earnings += parseFloat(element.Amount);
        });
        setMonthTotalEarning(earnings);
        setTransactions(data);
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (period === null && periods.length === 0) {
      var date = new Date();
      var _periods = [] as MonthlyPeriod[];
      for (var i = 0; i < 12; ++i) {
        _periods.push({
          month: i,
          year: date.getFullYear(),
          index: i,
        } as MonthlyPeriod);
      }
      setPeriods(_periods);
      if (period == null)
        setPeriod({
          index: date.getMonth(),
          month: date.getMonth(),
          year: date.getFullYear(),
          day: date.getDate(),
        });
    }

    fetchData(period!);
  }, [period]);

  return (
    <Container
      fluid
      style={{ height: portalStore.portalHeight, paddingTop: "5vh" }}
    >
      <Row>
        <h1 style={{ fontWeight: "bolder" }}>
          Overview | <span>2025</span>{" "}
        </h1>
        <div style={{ display: "flex", flexFlow: "row" }}>
          {periods.map((p, i) => (
            <MenuItem
              key={i}
              id={p.index + ""}
              onClick={() => {
                console.log("Selected Period", p);
                setPeriod(p);
              }}
            >
              <h2
                style={{
                  fontWeight: period?.index == i ? "bolder" : "normal",
                  color: period?.index == i ? "tomato" : "grey",
                }}
              >
                {StringifyOnlyMonthlyPeriod(p, period?.index == i)}
              </h2>
            </MenuItem>
          ))}
        </div>
      </Row>
      <Row>
        {loading ? <h1>Calculating...</h1> : <h2></h2>}

        {!loading ? (
          <>
            <Col
              style={{
                display: "flex",
                flexFlow: "column",
                background: "whitesmoke",
              }}
            >
              <h2>Earnings</h2>
              <h1>
                R <strong>{monthTotalEarning}</strong>
              </h1>
            </Col>
            <Col>Dashboard__</Col>
          </>
        ) : (
          <div></div>
        )}
      </Row>
    </Container>
  );
};

const date = new Date();
const availablePeriods = [
  {
    year: date.getFullYear(),
    month: date.getMonth(),
  },
] as MonthlyPeriod[];

export { AccountingDashboard };
